<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-compass`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22zm0-4c9.941 0 18-8.059 18-18S33.941 6 24 6 6 14.059 6 24s8.059 18 18 18zm10.53-27.265a1 1 0 00-1.265-1.265l-14.372 4.79a1 1 0 00-.632.633l-4.79 14.372a1 1 0 001.264 1.265l14.372-4.79a1 1 0 00.632-.633l4.79-14.372zM26.419 26.42l-7.257 2.419 2.42-7.257 7.256-2.419-2.42 7.257z"/></svg>
</template>
<script>

export default {
  name: 'IconCompass',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
